<template>
  <bottom-bar-layout class="page-reading-day"
                     :show-bar="render.footerShow"
                     :bar-height="100"
                     :shadow="false"
  >
    <ym-img class="page-reading-day-header"
            :src="require('@/pages/2021/ReadingDay/assets/img/audio_bg.png')"
    />
    <div class="page-reading-day-list">
      <audio-item v-for="(item,index) in list"
                  :key="index"
                  :item="item"
      />
    </div>
    <router-link v-if="render.footerShow"
                 slot="tabbar"
                 :to="render.footerPath"
                 class="page-reading-day-footer"
                 v-ym-report:MARKETING_2021READINGDAY_RADIO_VIP_BUY_CLICK=""
    >
      以上课程全部畅听<span>限时特惠¥699</span>
    </router-link>
  </bottom-bar-layout>
</template>

<script>
  import { getReadingDayAudioList } from '@/services/reading-day-2021';
  import BottomBarLayout from '@/layout/BottomBarLayout';
  import AudioItem from '@/pages/2021/ReadingDay/components/AudioItem';

  export default {
    name: 'ReadingDayAudio',
    components: {
      BottomBarLayout,
      AudioItem,
    },
    data() {
      return {
        list: [],
        render: {
          footerShow: false,
        },
      };
    },
    computed: {},
    methods: {
      async fetchData() {
        const data = await getReadingDayAudioList();
        this.list = data.list;
        this.render = data.render;
      },
    },
    created() {
      this.fetchData();
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .page-reading-day {
    min-height: 100%;
    background: #f76b5e;
    &-header {
      width: 100%;
      height: 600px;
    }
    &-list {
      position: relative;
      top: -45px;
      width: 100%;
      background: @color-white;
      border-radius: 35px;
      padding: 90px 0 100px;
      box-sizing: border-box;
    }
    &-footer {
      width: 100%;
      height: 100px;
      background: linear-gradient(0deg, #F4C470 0%, #F4DA89 100%);
      display: flex;
      align-items: center;
      justify-content: center;
      color: #333;
      font-size: 34px;
      font-weight: @font-weight-bold;
      span {
        font-size: 38px;
        margin-left: 20px;
      }
    }
  }
</style>
